/** @jsxImportSource @emotion/react */
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { tabs } from 'components/layouts/Tab';
import PrjInfoPage from './regist/PrjInfoPage';
import IvesResultPage from './regist/IvesResultPage';
import DtlIsptMatr from './regist/input/DtlIsptMatr';
import IvesAtcIspt from './regist/input/IvesAtcIspt';
import LineEqpNbuIspt from './regist/input/LineEqpNbuIspt';
import MdlSpecInfoPage from './regist/input/MdlSpecInfo';
import { TabMenu } from 'models/md/MdIves';
import { useLocation } from 'react-router-dom';
import IvesResultAnlsPage from './regist/IvesResultAnlsPage';

export interface DefaultProps {
  elmPrjId: string;
}

const MdIvesCmpuRegPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const state = { ...location.state };

  const [locationState, setLocationState] = useState({ ...location.state });
  const [elmPrjId, setElmPrjId] = useState(state.elmPrjId);
  const [currentTabIndex, setCurrentTabIndex] = useState<number>(state?.tabIdx || 0);

  const tabMenus: TabMenu[] = [
    { id: 'INFO', name: t('setup.label.프로젝트 정보', '프로젝트 정보') },
    { id: 'INPUT', name: t('setup.label.형개발 투자비 input', '형개발 투자비 input') },
    { id: 'RESULT', name: t('setup.label.투자비 산출 결과', '투자비 산출 결과') },
    { id: 'DETAIL', name: t('setup.label.투자비 산출 결과 분석', '투자비 산출 결과 분석') },
  ];

  useEffect(() => {
    if (location.pathname === '/md/ives-cmpu/detail') {
      setLocationState(state);
    }
  }, [location]);

  useEffect(() => {
    setElmPrjId(locationState?.elmPrjId || '');
    setCurrentTabIndex(locationState?.tabIdx || 0);
  }, [locationState?.elmPrjId, locationState?.tabIdx]);

  return (
    <>
      <div css={tabs.wrap} className="mt-6">
        <Tabs
          value={currentTabIndex}
          onChange={(e, newValue) => setCurrentTabIndex(newValue)}
          css={tabs.tab}
        >
          {tabMenus.map((o, idx) => (
            <Tab
              key={o.id}
              label={o.name}
              id={`td-ives-cmpu-tab-${idx}`}
              aria-controls={`md-ives-cmpu-tabpanel-${idx}`}
            />
          ))}
        </Tabs>
      </div>
      <TabPanel value={currentTabIndex} index={0}>
        <PrjInfoPage elmPrjId={elmPrjId} />
      </TabPanel>
      <TabPanel value={currentTabIndex} index={1}>
        <>
          <MdlSpecInfoPage elmPrjId={elmPrjId} />
          <LineEqpNbuIspt elmPrjId={elmPrjId} />
          <IvesAtcIspt elmPrjId={elmPrjId} />
          <DtlIsptMatr elmPrjId={elmPrjId} />
        </>
      </TabPanel>
      <TabPanel value={currentTabIndex} index={2}>
        <IvesResultPage elmPrjId={elmPrjId} />
      </TabPanel>
      <TabPanel value={currentTabIndex} index={3}>
        <IvesResultAnlsPage elmPrjId={elmPrjId} />
      </TabPanel>
    </>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function TabPanel(props: { [x: string]: any; children: any; value: any; index: any }) {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`md-ives-input-tabpanel-${index}`}
      className="mb-5"
    >
      <div>{children}</div>
    </div>
  );
}

export default MdIvesCmpuRegPage;
